module.exports = __webpack_public_path__ + "static/media/integration-two.aa04fddf.svg";